import React from 'react'
import withTranslator from '../../HOCComponents/withTranslator'
import styled from 'styled-components'
import { Button } from '../../UIComponents/StyledButtons'
import { useFormContext } from 'react-hook-form'

import capitalize from 'lodash/capitalize'
import themeColors from '@layers-frontend/commons/styles/themeColors'

const Wrapper = styled.div`
  display: flex;
  justify-content: space-between;
  border-top: 1px solid ${themeColors.mintBorder};
  padding: 1.5rem;
`

function FieldSeasonFormFooter({ t, closeModal, onConfirm, hasRoleDemo }) {
  const { handleSubmit } = useFormContext()

  return (
    <Wrapper>
      <Button pill="cancel" onClick={closeModal} label={capitalize(t('cancel'))} />
      <Button pill="confirm" disabled={hasRoleDemo} label={capitalize(t('save_'))} onClick={handleSubmit(onConfirm)} testId="save-button" />
    </Wrapper>
  )
}

export default withTranslator(FieldSeasonFormFooter)
